$(document).ready(function() {
	var productGalleryBreakpoint = 1040;
	var $productGallery = $('#product-gall');
	var $productOptions = $('#hg-vars');
	var productGalleryIsStatic = null;
	var productGalleryResizeTimer = null;
	var productVariantData = [];
	var currentProductVariant = null;
	var productPriceRequestId = 0;

	function getSliderOptions($slider) {
		var sliderOptions = $slider.attr('data-flickity');

		if (!sliderOptions) {
			return {};
		}

		try {
			return JSON.parse(sliderOptions);
		} catch (error) {
			return {};
		}
	}

	function getFlickityInstance($slider) {
		if (!$slider.length || typeof Flickity === 'undefined') {
			return null;
		}

		return Flickity.data($slider[0]);
	}

	function hasFlickityInstance($slider) {
		return !!getFlickityInstance($slider);
	}

	function syncProductGalleryMedia(isDesktop) {
		if (!$productGallery.length) {
			return;
		}

		$productGallery.find('.bgcov').each(function() {
			var $slide = $(this);
			var desktopImage = $slide.attr('data-f-pc');
			var mobileImage = $slide.attr('data-f-m');

			if (isDesktop) {
				if (desktopImage) {
					$slide.css('background-image', 'url(' + desktopImage + ')');
				}
				$slide.attr('data-flickity-bg-lazyload', desktopImage || '');
			} else if ($slide.hasClass('first-sl')) {
				if (mobileImage) {
					$slide.css('background-image', 'url(' + mobileImage + ')');
				}
			} else {
				$slide.css('background-image', '');
				$slide.attr('data-flickity-bg-lazyload', mobileImage || '');
			}
		});
	}

	function setProductGalleryCounter(index) {
		$productGallery.closest('.has-nav').find('.cur-c').html(index + 1);
	}

	function getProductGallerySlideIndexByMediaId(mediaId) {
		var slideIndex = -1;

		if (!$productGallery.length || !mediaId) {
			return slideIndex;
		}

		$productGallery.find('.hg-slide').each(function(index) {
			if (String($(this).attr('data-media-id')) === String(mediaId)) {
				slideIndex = index;
				return false;
			}
		});

		return slideIndex;
	}

	function scrollProductGalleryToMedia(mediaId) {
		var slideIndex = getProductGallerySlideIndexByMediaId(mediaId);
		var desktopScrollOffset = 60;
		var $targetSlide;
		var targetTop;

		if (slideIndex < 0) {
			return;
		}

		$targetSlide = $productGallery.find('.hg-slide').eq(slideIndex);

		if (productGalleryIsStatic) {
			if ($targetSlide.length) {
				targetTop = $targetSlide.offset().top - desktopScrollOffset;
				$('html, body').stop(true).animate({
					scrollTop: Math.max(targetTop, 0)
				}, 400);
			}
			return;
		}

		if (hasFlickityInstance($productGallery)) {
			$productGallery.flickity('select', slideIndex, false, true);
			setProductGalleryCounter(slideIndex);
		}
	}

	function destroyProductGallery() {
		if (!$productGallery.length) {
			return;
		}

		if (hasFlickityInstance($productGallery)) {
			$productGallery.flickity('destroy');
		}

		$productGallery.addClass('product-gall-static');
		setProductGalleryCounter(0);
		$productGallery.find('.hg-video').trigger('pause');
		$productGallery.find('.hg-video').first().trigger('play');
	}

	function initProductGallery() {
		if (!$productGallery.length) {
			return;
		}

		if (hasFlickityInstance($productGallery)) {
			$productGallery.flickity('destroy');
		}

		$productGallery.removeClass('product-gall-static');
		$productGallery.flickity(getSliderOptions($productGallery));

		$productGallery.flickity('select', 0, false, true);
		$productGallery.flickity('resize');
		setProductGalleryCounter(0);
	}

	function syncProductGalleryState(force) {
		var isDesktop = $(window).width() > productGalleryBreakpoint;

		if (!$productGallery.length) {
			return;
		}

		if (!force && productGalleryIsStatic === isDesktop) {
			return;
		}

		syncProductGalleryMedia(isDesktop);

		if (isDesktop) {
			destroyProductGallery();
		} else {
			initProductGallery();
		}

		productGalleryIsStatic = isDesktop;
	}

	function getProductSectionId() {
		return $productOptions.attr('data-section-id') || $('#hg-buy-btn').attr('data-section-id') || '';
	}

	function getProductUrl() {
		return $productOptions.attr('data-product-url') || $('#hg-buy-btn').attr('data-product-url') || window.location.pathname;
	}

	function getProductVariantData() {
		var sectionId = getProductSectionId();
		var $variantDataNode;

		if (productVariantData.length) {
			return productVariantData;
		}

		if (!sectionId) {
			return [];
		}

		$variantDataNode = $('#HgVariantData-' + sectionId);

		if (!$variantDataNode.length) {
			return [];
		}

		try {
			productVariantData = JSON.parse($variantDataNode.text());
		} catch (error) {
			productVariantData = [];
		}

		return productVariantData;
	}

	function getSelectedProductOptions() {
		var selectedOptions = [];

		if (!$productOptions.length) {
			return selectedOptions;
		}

		$productOptions.find('.hg-option-group').each(function() {
			var optionIndex = parseInt($(this).attr('data-option-position'), 10) - 1;
			var $activeValue = $(this).find('.product-option-value.active').first();

			selectedOptions[optionIndex] = $activeValue.attr('data-option-value') || '';
		});

		return selectedOptions;
	}

	function variantMatchesOptions(variant, options) {
		var optionIndex;

		if (!variant || !options.length) {
			return false;
		}

		for (optionIndex = 0; optionIndex < options.length; optionIndex++) {
			if (String(variant.options[optionIndex] || '') !== String(options[optionIndex] || '')) {
				return false;
			}
		}

		return true;
	}

	function findVariantByOptions(options) {
		var variants = getProductVariantData();

		return $.grep(variants, function(variant) {
			return variantMatchesOptions(variant, options);
		})[0] || null;
	}

	function findVariantByPrefix(options, optionIndex, preferAvailable) {
		var variants = getProductVariantData();

		return $.grep(variants, function(variant) {
			var prefixIndex;

			if (preferAvailable && !variant.available) {
				return false;
			}

			for (prefixIndex = 0; prefixIndex <= optionIndex; prefixIndex++) {
				if (String(variant.options[prefixIndex] || '') !== String(options[prefixIndex] || '')) {
					return false;
				}
			}

			return true;
		})[0] || null;
	}

	function setActiveProductOptions(variant) {
		if (!$productOptions.length || !variant) {
			return;
		}

		$productOptions.find('.hg-option-group').each(function() {
			var optionIndex = parseInt($(this).attr('data-option-position'), 10) - 1;
			var selectedValue = variant.options[optionIndex];
			var $optionValues = $(this).find('.product-option-value');

			$optionValues.removeClass('active');
			$optionValues.filter('[data-option-value="' + selectedValue.replace(/"/g, '\\"') + '"]').addClass('active');
		});
	}

	function updateProductOptionAvailability(selectedOptions) {
		var variants = getProductVariantData();

		if (!$productOptions.length || !variants.length) {
			return;
		}

		$productOptions.find('.hg-option-group').each(function() {
			var $group = $(this);
			var optionPosition = parseInt($group.attr('data-option-position'), 10) - 1;

			$group.find('.product-option-value').each(function() {
				var $value = $(this);
				var optionValue = $value.attr('data-option-value');
				var matchingVariants = $.grep(variants, function(variant) {
					var previousOptionIndex;

					for (previousOptionIndex = 0; previousOptionIndex < optionPosition; previousOptionIndex++) {
						if (String(variant.options[previousOptionIndex] || '') !== String(selectedOptions[previousOptionIndex] || '')) {
							return false;
						}
					}

					return String(variant.options[optionPosition] || '') === String(optionValue || '');
				});
				var hasAvailableVariant = $.grep(matchingVariants, function(variant) {
					return variant.available;
				}).length > 0;

				$value.toggleClass('na-var', matchingVariants.length === 0);
				$value.toggleClass('out-var', matchingVariants.length > 0 && !hasAvailableVariant);
			});
		});
	}

	function updateProductVariantInput(variant) {
		if (!variant || !variant.id) {
			return;
		}

		$('form[action="/cart/add"]').find('.product-variant-id').val(variant.id).trigger('change');
	}

	function updateProductVariantUrl(variant) {
		var productUrl;

		if (!variant || !variant.id) {
			return;
		}

		productUrl = getProductUrl();

		window.history.replaceState({}, document.title, productUrl + '?variant=' + variant.id);
	}

	function updateNotifyVariantState(variant) {
		var $notifySelect = $('.restock-alerts-variant-select');

		$('.variations-not span').removeClass('active');

		if (!variant || !variant.id) {
			return;
		}

		$('.variations-not span[data-id="' + variant.id + '"]').addClass('active');

		if ($notifySelect.length) {
			$notifySelect.val(variant.id).trigger('change');
		}
	}

	function updateProductBuyButtonState(variant) {
		var $buyButton = $('#hg-buy-btn');
		var isSoldProduct = $buyButton.attr('data-sold-product') === 'true';
		var isComingSoonProduct = $buyButton.attr('data-coming-soon-product') === 'true';
		var isUnavailable = !variant || !variant.available;
		var buttonLabel = $buyButton.attr('data-label-add') || $buyButton.attr('data-cs') || '';
		var statusLabel = '';

		if (!$buyButton.length) {
			return;
		}

		$buyButton.removeClass('n-btn stock-out cs_btn otu_btn');

		if (isUnavailable) {
			if (isSoldProduct) {
				$buyButton.addClass('otu_btn');
				buttonLabel = $buyButton.attr('data-label-sold') || buttonLabel;
				statusLabel = $buyButton.attr('data-status-out') || '';
			} else if (isComingSoonProduct) {
				$buyButton.addClass('cs_btn n-btn');
				buttonLabel = $buyButton.attr('data-label-coming-soon') || buttonLabel;
				statusLabel = $buyButton.attr('data-status-notify') || '';
			} else {
				$buyButton.addClass('stock-out n-btn');
				buttonLabel = $buyButton.attr('data-label-out-of-stock') || buttonLabel;
				statusLabel = $buyButton.attr('data-status-notify') || '';
			}
		}

		$buyButton.find('.sp-b-name').html(buttonLabel);
		$buyButton.find('.hg-buy-status').html(statusLabel);
	}

	function updateProductPrice(variant) {
		var sectionId = getProductSectionId();
		var productUrl = getProductUrl();
		var requestId;

		if (!variant || !variant.id || !sectionId) {
			return;
		}

		requestId = productPriceRequestId + 1;
		productPriceRequestId = requestId;

		fetch(productUrl + '?variant=' + variant.id + '&section_id=' + sectionId)
			.then(function(response) {
				return response.text();
			})
			.then(function(responseText) {
				var html;
				var sourcePrice;

				if (requestId !== productPriceRequestId) {
					return;
				}

				html = new DOMParser().parseFromString(responseText, 'text/html');
				sourcePrice = html.getElementById('HgPrice-' + sectionId);

				if (sourcePrice && $('#HgPrice-' + sectionId).length) {
					$('#HgPrice-' + sectionId).html(sourcePrice.innerHTML);
				}
			})
			.catch(function(error) {
				console.error(error);
			});
	}

	function applySelectedProductVariant(variant, syncUrl, syncMedia) {
		if (!variant) {
			return;
		}

		currentProductVariant = variant;
		setActiveProductOptions(variant);
		updateProductOptionAvailability(variant.options);
		updateProductVariantInput(variant);
		updateProductBuyButtonState(variant);
		updateNotifyVariantState(variant);
		updateProductPrice(variant);

		if (syncUrl) {
			updateProductVariantUrl(variant);
		}

		if (syncMedia && variant.featured_media && variant.featured_media.id) {
			scrollProductGalleryToMedia(variant.featured_media.id);
		}
	}

	function initProductOptionSelector() {
		var selectedOptions;
		var initialVariant;

		if (!$productOptions.length) {
			return;
		}

		if (!getProductVariantData().length) {
			return;
		}

		selectedOptions = getSelectedProductOptions();
		initialVariant = findVariantByOptions(selectedOptions);

		if (!initialVariant) {
			initialVariant = getProductVariantData()[0] || null;
		}

		applySelectedProductVariant(initialVariant, false, false);
	}

	if ($(window).width() > 1040) {

	}else{
		$('.cur-nav').on('click', function() {
			if(!$(this).hasClass('active')){
				$(this).addClass('active');
			}else{
				$(this).removeClass('active');
			}
		});
	}



	setTimeout(function() {
		$('body').addClass('page-load');
		$(window).trigger('scroll');
	}, 200);

	if (Cookies.get('c-fw')) {
		$('#fw-popup').hide();
		$('body').removeClass('fw-p-open');
	}

	$('#c-fw').on('click', function() {
		Cookies.set('c-fw', 'ok', {
			expires: 7
		});
		$('body').removeClass('fw-p-open');
	});



	$('.pc-h.acc-cur li ').on('click', function() {
		$cur_code = $(this).attr('data-c');
		if (!$(this).hasClass('active')) {
			$(this).addClass('active');
			$(this).nextAll().removeClass('active');
			$(this).prevAll().removeClass('active');
			// $('.etranslate-currency-dropdown .etranslate-selector-dropdown-item[data-code="' + $cur_code + '"]').trigger('click');
			// $('.etranslate-change button').trigger('click');
			$('#menu-i.active').trigger('click');
		}
	});



	$(function() {
		$(".h-sl").swipe({
			fingers: 'all',
			swipeLeft: swipe1,
			swipeRight: swipe1,
			allowPageScroll: "auto"
		});

		function swipe1(event, direction, distance, duration, fingerCount) {
			if (!hasFlickityInstance($(this))) {
				return;
			}

			if (direction == 'left') {
				$(this).flickity('next');
			} else if (direction == 'right') {
				$(this).flickity('previous');
			}
		}

	});

	syncProductGalleryState(true);
	initProductOptionSelector();
	$(window).on('resize.product-gallery', function() {
		clearTimeout(productGalleryResizeTimer);
		productGalleryResizeTimer = setTimeout(function() {
			syncProductGalleryState();
		}, 120);
	});

	setTimeout(function() {
		// if ($('.etranslate-currency-list-button > .etranslate-currency-name').length > 0) {
		// 	$c_cur = $('.etranslate-currency-list-button > .etranslate-currency-name').html().replace(/\s+/g, '');
		// } else {
		// 	$c_cur = $('.etranslate-selector-list-button-content > .etranslate-currency-name').html().replace(/\s+/g, '');
		// }
		$('#cur-cur').html($c_cur);
		// $('.acc-cur span[data-c="' + $c_cur + '"]').addClass('hg-h');
		$('.acc-cur span[data-c="' + $c_cur + '"]').hide();
	}, 2250);
	if ($(window).width() < 1023) {
		// setTimeout(function() {
		// 	$c_cur = $('.etranslate-currency-list-button > .etranslate-currency-name').html();
		// 	$('.acc-cur li[data-c="' + $c_cur + '"]').addClass('active');
		// }, 700);
	}

	$('#cl-sing-f').on('click', function() {
		Cookies.set('sing-form', 'ok', {
			expires: 14
		});
		$('#sing-pop').removeClass('open');
	});

	document.addEventListener('click', function (event) {
		const block = document.querySelector('#sing-pop');
		const innerElement = document.querySelector('#sing-pop .hg-sing-grid');
		if (!block) return;
		if (block.contains(event.target)) {
			if (!innerElement.contains(event.target)) {
				Cookies.set('sing-form', 'ok', {
					expires: 14
				});
				$('#sing-pop').removeClass('open');
			} else {}
		} else {}
	});

	$('#cl-country-i').on('click', function() {
		Cookies.set('countryInfoPopup', 'ok', {
			expires: 14
		});
		$('#countryInfoPopup').removeClass('open');
		if(!Cookies.get('sing-form-time')) {
			const currentTime = new Date().getTime();
			const expireTime = currentTime + 3 * 60 * 1000;
			Cookies.set('sing-form-time', expireTime, {expires: 30});
		}
	});
	if (Cookies.get('c-mess')) {
		$('#c_mess').hide();
	}
	$('#cl-c').on('click', function() {
		Cookies.set('c-mess', 'ok', {
			expires: 7
		});
		$('#c_mess').fadeOut();
	});
	$('.acc-cur span:not(.lang_hg_uk, .lang_hg_en)').on('click', function() {
		$cur_code = $(this).attr('data-c');
		$(this).hide();
		$(this).nextAll().show();
		$(this).prevAll().show();
		$('#cur-cur').html($cur_code);
		// $('.etranslate-selector-dropdown-item[data-code="' + $cur_code + '"]').trigger('click');
		// $('.etranslate-change button').trigger('click');
	});

	$('.acc-cur.lang-s span').on('click', function() {
		$cur_code = $(this).attr('data-c');
		$(this).hide();
		$(this).nextAll().show();
		$(this).prevAll().show();
		$('#cur-cur').html($cur_code);
		// $('.etranslate-language-dropdown .etranslate-selector-dropdown-item[data-code="' + $cur_code + '"]').trigger('click');
		// $('.etranslate-change button').trigger('click');
	});

	$('#close-serach').on('click', function() {
		$('body').removeClass('search-open');
	});

	$('#nav-hg a[data-open-search]').on('click', function() {
		$('#menu-i.active').trigger('click');
		$('body').addClass('search-open')

	});
    $('#header-search a[data-open-search]').on('click', function() {
        $('#menu-i.active').trigger('click');
        $('body').addClass('search-open')

    });


	$('.ll-video').each(function(index) {
		$pc_v = $(this).attr('data-v-pc');
		$m_v = $(this).attr('data-v-m');
		if ($(window).width() > 1040) {
			$(this).find('source').attr('src', $pc_v);
			$(this).trigger('load');
			$(this).trigger('play');

		} else {
			$(this).find('source').attr('src', $m_v);
			$(this).trigger('load');
			$(this).trigger('play');
		}
	});



	$l_c = 0;
	$l_l = $('header .header-item').length;
	$l_lp = $l_l * 250;
	//alert($l_l );
	$('header .header-item').each(function() {
		$l_c++;
		$lpa = 400 * $l_c;

		setTimeout("$('header .header-item:nth-child(" + $l_c + ")').addClass('fade_s')", $lpa);

	});
	setTimeout("$('body').addClass('end_preload')", $l_lp);


	$(window).scroll(function(e) {
		$scroll_i = $(window).scrollTop();
		$header_h = $('header').height();
		if ($scroll_i > 1) {
			if (!$('header').hasClass('scroll-h')) {
				$('header').addClass('scroll-h');
			}
		} else {
			$('header').removeClass('scroll-h');
		}

	});
	// Cookies.set('shop-th', 'ok', {
	// 	expires: 7
	// });
	$('#v-tclm').on('click', function() {
		$('#v-oclm').removeClass('active');
		$(this).addClass('active');
		Cookies.set('shop-th', 'ok', {
			expires: 7
		});
		Cookies.remove('shop-oh');
		$('body').addClass('s-t-clm');
	});
	$('#v-oclm').on('click', function() {
		$('#v-tclm').removeClass('active');
		$(this).addClass('active');
		Cookies.remove('shop-th');
		Cookies.set('shop-oh', 'ok', {
			expires: 7
		});
		$('body').removeClass('s-t-clm');
	});
	if (Cookies.get('shop-th')) {
		Cookies.remove('shop-oh');
		setTimeout(function() {
			$('#v-oclm').removeClass('active');
			$('#v-tclm').addClass('active');
		}, 100);
		$('body').addClass('s-t-clm');
	} else {
		$('body').removeClass('s-t-clm');
	}

	if (Cookies.get('shop-oh')) {
		Cookies.remove('shop-th');
		$('#v-oclm').addClass('active');
		$('#v-tclm').removeClass('active');
		$('body').removeClass('s-t-clm');
	} else {

	}

	$('#menu-i').on('click', function() {
		if (!$(this).hasClass('active')) {
			$(this).addClass('active');
			$('body').addClass('m-open');
			if ($(window).width() > 1040) {
				$('#menu-img .bgcov_v video').trigger('play');
			}
		} else {
			$(this).removeClass('active');
			$('body').removeClass('m-open');
			if ($(window).width() > 1040) {
				$('#menu-img .bgcov_v video').trigger('pause');
			}
		}
	});

	$('#f-btn').on('click', function() {
		$('body').addClass('f-open');

	});
	$('#app-filter-hg').on('click', function() {
		$('body').removeClass('f-open');
	});
	$('#f-close').on('click', function() {
		$('body').removeClass('f-open');
	});
	$('#f-close-p').on('click', function() {
		$('body').removeClass('f-open');
	});

	$('#hg-sort .sort-item').on('click', function() {
		if (!$(this).hasClass('active')) {
			$(this).addClass('active');
			$(this).nextAll().removeClass('active');
			$(this).prevAll().removeClass('active');
			$('#SortBy-mobile').find('option[value="' + $(this).attr('data-val') + '"]').trigger('click')
			$('#SortBy-mobile').find('option[value="' + $(this).attr('data-val') + '"]').prevAll().removeAttr('selected');
			$('#SortBy-mobile').find('option[value="' + $(this).attr('data-val') + '"]').nextAll().removeAttr('selected');
			$('#SortBy-mobile').find('option[value="' + $(this).attr('data-val') + '"]').attr('selected', 'selected');

			$('#SortBy-mobile').val($(this).attr('data-val'));
			$('#SortBy-mobile').trigger('change');
		} else {

		}
	});



	$('.hg-nav-items.has-child > a').each(function(index) {
		$(this).attr('href', '#');
	});
	$('.hg-nav-items.has-child > a').on('click', function() {
		if (!$(this).parent().hasClass('active')) {
			$(this).parent().addClass('active');
			$(this).parent().nextAll().removeClass('active').next('ul').slideUp();
			$(this).parent().prevAll().removeClass('active').next('ul').slideUp();
			$(this).parent().next('ul').slideDown();
		} else {
			$(this).parent().removeClass('active');
			$(this).parent().next('ul').slideUp();
		}
	});
	$('.close-sub').on('click', function() {

		$(this).parent('ul').prev('.hg-nav-items.has-child').removeClass('active');
		$(this).parent('ul').slideUp();

	});

	$('.tit-i h1').each(function(index) {
		if ($(this).width() > $(this).parent().width()) {
			//$(this).parents('.tit-grid').addClass('has-an-ts');
		}
	});

	$('#hg-vars').on('click', '.product-option-value', function() {
		var $clickedValue = $(this);
		var selectedOptions;
		var optionIndex;
		var matchedVariant;

		if ($clickedValue.hasClass('na-var')) {
			return;
		}

		selectedOptions = getSelectedProductOptions();
		optionIndex = parseInt($clickedValue.attr('data-option-position'), 10) - 1;
		selectedOptions[optionIndex] = $clickedValue.attr('data-option-value') || '';

		matchedVariant = findVariantByOptions(selectedOptions);

		if (!matchedVariant) {
			matchedVariant = findVariantByPrefix(selectedOptions, optionIndex, true) || findVariantByPrefix(selectedOptions, optionIndex, false);
		}

		if (!matchedVariant) {
			return;
		}

		$('#hg-vars').removeClass('c-size');
		applySelectedProductVariant(matchedVariant, true, true);
	});


	$('*#hg-buy-btn').on('click', function(e) {
		var variantId = currentProductVariant && currentProductVariant.id ? currentProductVariant.id : $('form[action="/cart/add"]').find('.product-variant-id').val();

		if (!$(this).hasClass('n-btn') && !$(this).hasClass('otu_btn')) {
			if (variantId) {
				$.ajax({
					type: 'POST',
					url: '/cart/add.js',
					data: {
						quantity: 1,
						id: variantId,
					},
					dataType: 'json',
					success: function(data) {
						$('#hg-buy-btn').addClass('adding-hg');
						$('#mc-cart-hg').removeClass('emp_c');
						$('#mc-cart-hg').removeClass('emp_c');
						$('#mc-cart-hg.mc-cart-hg-custom').trigger('click');
						$('#m-cart-hg').removeClass('emp_car');

					},
					error: function(data) {
						console.log('data eror', data)
						alert(data.responseJSON.description)
					}
				});
			} else {
				$('#hg-vars').addClass('c-size');
			}
		}

	});

	var c_lang = $('html').attr('lang');
	if (c_lang == 'en') {
		hg_c_lang = '';
	} else {
		hg_c_lang = c_lang;
	}

	$('#mc-cart-hg:not(.mc-cart-hg-custom)').on('click', function() {
		if (!$(this).hasClass('active')) {
			$('body').addClass('mc-open');
			$(this).addClass('active');

			if (!$(this).hasClass('emp_c')) {
				$.ajax({
					type: "GET",
					url: 'https://bevza.com/' + hg_c_lang + '/cart',
					cache: false,
					dataType: 'html',
					beforeSend: function(xhr) {
						$('#m-cart-hg').addClass('loading-mc');
						$('#m-cart-hg .hg-cart-grid').remove();
					},
					success: function(response) {
						if (response) {
							$('#m-cart-hg').removeClass('loading-mc');
							$c_hg = $(response).find('.hg-cart-grid');
							$c_items = $(response).find('.hg-cart-grid').attr('data-cc-hg');
							$('#mc-cart-hg span').removeClass('hg-h');
							$('#mc-cart-hg span').html($c_items);
							$('#m-cart-hg').append($c_hg);
							if ($c_items == 0) {
								$('#m-cart-hg').addClass('emp_car');
							} else {
								$('#m-cart-hg').removeClass('emp_car');
							}
							$h_mc_n = $('header').height() + $('#m-cart-hg .cart-hg-btns ').height() + ($('#m-cart-hg .sp-mc').height() * 2);
							$h_mc = $(window).innerHeight() - $h_mc_n;
							$('#m-cart-hg .cart-items-grid').css('max-height', $h_mc);

						}
					}
				});
			}
		} else {
			$(this).removeClass('active');
			$('body').removeClass('mc-open');
		}

	});
	$('#close-mc').on('click', function() {
		$('body').removeClass('mc-open');
	});
	$('.sl-nav .prev-i').on('click', function() {
		var $slider = $(this).parents('.has-nav').find('.h-sl');

		if (hasFlickityInstance($slider)) {
			$slider.flickity('previous');
		}
	});

	$('.sl-nav .next-i').on('click', function() {
		var $slider = $(this).parents('.has-nav').find('.h-sl');

		if (hasFlickityInstance($slider)) {
			$slider.flickity('next');
		}
	});

	// on hover show second image for desktop
	function checkMediaQuery() {
		return window.matchMedia('(min-width: 750px)').matches;
	}

	function prepareProductCardCarousel($carousel) {
		if (!$carousel.length || typeof $.fn.flickity === 'undefined') {
			return false;
		}

		if (!hasFlickityInstance($carousel)) {
			$carousel.flickity(getSliderOptions($carousel));
		}

		$carousel.off('change.flickity.cardVideo').on('change.flickity.cardVideo', function(event, index) {
			updateProductCardVideos($(this), index);
		});

		return hasFlickityInstance($carousel);
	}

	function getProductCardHoverIndex($carousel) {
		var $slides = $carousel.find('.hg-slide');
		var videoIndex = $slides.index($slides.filter('.video_sl').first());

		if (videoIndex >= 0) {
			return videoIndex;
		}

		return $slides.length > 1 ? 1 : 0;
	}

	function updateProductCardVideos($carousel, activeIndex) {
		$carousel.find('.hg-slide').each(function(index) {
			var $videos = $(this).find('.hg-video');

			if (index === activeIndex) {
				$videos.trigger('play');
			} else {
				$videos.trigger('pause');
			}
		});
	}

	function addHoverHandlers() {
		$('.hg-prod').hover(
			function () {
				var $carousel = $(this).find('.prods-sl-n');

				if (!prepareProductCardCarousel($carousel)) {
					return;
				}

				var hoverIndex = getProductCardHoverIndex($carousel);
				$carousel.flickity('select', hoverIndex, false, true);
				updateProductCardVideos($carousel, hoverIndex);
			},
			function () {
				var $carousel = $(this).find('.prods-sl-n');

				if (!prepareProductCardCarousel($carousel)) {
					return;
				}

				$carousel.flickity('select', 0, false, true);
				updateProductCardVideos($carousel, 0);
			}
		);
	}

	function removeHoverHandlers() {
		$('.hg-prod').off('mouseenter mouseleave');
	}

	if (checkMediaQuery()) {
		addHoverHandlers();
	}

	$(window).resize(function() {
		if (checkMediaQuery()) {
			removeHoverHandlers();
			addHoverHandlers();
		} else {
			removeHoverHandlers();
		}
	});
// on hover show second image for desktop

	$('#sg-btn').on('click', function() {
		$('body').addClass('sg-open');
	});
	$('#cr-btn').on('click', function() {
		$('body').addClass('cg-open');
	});

	$('#sg-prod .hg-cl').on('click', function() {
		$('body').removeClass('sg-open');
	});
	$('#cg-prod .hg-cl').on('click', function() {
		$('body').removeClass('cg-open');
	});


	$('.gall-item').on('click', function() {
		var cur_gall = $(this).attr('data-g');
		if (cur_gall) {
			$('#full-gall .hg-sl').flickity('select', cur_gall, false, true);
			$('body').addClass('gall-open');
		}
	});

	$('#close-f-gall').on('click', function() {
		$('body').removeClass('gall-open');
	});

	$('#rest-pass-btn').on('click', function(event) {
		$('#customer_login').slideUp();
		$('#reset-pass').slideDown();

	});
	$('#cl-pass-btn').on('click', function(event) {
		$('#customer_login').slideDown();
		$('#reset-pass').slideUp();

	});
	$('#cl-pass-btn').on('click', function(event) {
		$('#customer_login').slideDown();
		$('#reset-pass').slideUp();

	});
	$('.hg-sp-btn').on('click', function(event) {
		$sp_ob = $(this).attr('aria-controls');
		$('#' + $sp_ob + '').slideDown();

	});
	$('.close-ard-form').on('click', function(event) {
		$sp_ob = $(this).attr('aria-controls');
		$('#' + $sp_ob + '').slideUp();

	});
	$('.hg-acc select').select2();
	$('.h-sl').on('change.flickity', function(event, index) {
		$slide_p = index + 1;
		$(this).parents('.has-nav').find('.cur-c').html($slide_p);
		$('.hg-slide:nth-child(' + $slide_p + ')').find('.hg-video').trigger('play');
		$('.hg-slide:nth-child(' + $slide_p + ')').nextAll().find('.hg-video').trigger('pause');
		$('.hg-slide:nth-child(' + $slide_p + ')').prevAll().find('.hg-video').trigger('pause');
	});
	$('.h-sl').on('change.flickity', function(event, index) {
		$slide_p = index + 1;
		$('.bgcov:nth-child(' + $slide_p + ')').find('video').trigger('play');
		$('.bgcov:nth-child(' + $slide_p + ')').nextAll().find('video').trigger('pause');
		$('.bgcov:nth-child(' + $slide_p + ')').prevAll().find('video').trigger('pause');
	});

	if ($(window).width() > 1040) {
		$("#nav-hg li").hover(function() {
			$m_img = $(this).find('a').attr('data-img');
			$m_video = $(this).find('a').attr('data-video');
			if ($m_img) {
				$('#menu-img .bgcov_v').fadeOut();
				$('#menu-img .bgcov').fadeIn();
				$('#menu-img .bgcov').css('opacity', '1');
				$('#menu-img .bgcov').css('background-image', 'url(' + $m_img + ')');
			}
			if ($m_video) {
				$('#menu-img .bgcov').fadeOut();
				$('#menu-img .bgcov_v').fadeIn();
				$('#menu-img .bgcov_v').css('opacity', '1');
				$('#menu-img .bgcov_v').find('source').attr('src', $m_video);
				$('#menu-img .bgcov_v video').trigger('load');
				$('#menu-img .bgcov_v video').trigger('play');

			}

		}, function() {

		});

		$(".prod-v").hover(function() {
			$(this).find('video').trigger('play');
		}, function() {
			$(this).find('video').trigger('pause');
		});
	} else {
		$('span[for="SortBy-mobile"]').on('click', function() {
			if (!$(this).hasClass('active')) {
				$(this).addClass('active');
				$(this).next('div').slideDown();
			} else {
				$(this).removeClass('active');
				$(this).next('div').slideUp();
			}
		});
	}

	//lang nav
	$('.lang_hg_uk').on('click', function() {
		$('#cur-lang').html('UA');
		if (!$(this).hasClass('active')) {
			Cookies.set('lang_hg', 'uk', {
				expires: 7
			});
			$('.lang_hg_uk').addClass('active');
			$('.lang_hg_en').removeClass('active');
			var lang_r = 'uk';
			var cur_d_url = window.location.host;

			var url_cur_n = document.location.href;
			var url_cur = document.location.pathname.substring(1)
			// var add_turl = url_cur_n.replace("https://bevza.com/", "/uk/");

			var find_url_fl = url_cur.split("/");
			if (find_url_fl[0] !== 'uk') {
				window.location.replace('' + add_turl + '');
			}

			$hg_ll = $('.log-in-button').attr('href');
			$hg_cl = $('.site-header__cart-toggle').attr('href');
			$hg_sl = $('.search-button').attr('href');
			$('.log-in-button').attr('href', '/uk' + $hg_ll + '');
			$('.site-header__cart-toggle').attr('href', '/uk' + $hg_cl + '');
			$('.search-button').attr('href', '/uk' + $hg_sl + '');
		}
	});
	$('.lang_hg_en').on('click', function() {
		$('#cur-lang').html('EN');
		if (!$(this).hasClass('active')) {
			Cookies.remove('lang_hg');
			$('.lang_hg_en').addClass('active');
			$('.lang_hg_en').html('EN');
			$('.lang_hg_uk').removeClass('active');
			var lang_r = '';
			var cur_d_url = window.location.host;

			var url_cur_n = document.location.href;
			var url_cur = document.location.pathname.substring(1)
			var add_turl = url_cur_n.replace("https://bevza.com/uk/", "/");

			var find_url_fl = url_cur.split("/");
			if (find_url_fl[0] == 'uk') {
				window.location.replace('' + add_turl + '');
			}

			$hg_ll = '/account/login';
			$hg_cl = '/cart/';
			$hg_sl = '/search/';
			$('.log-in-button').attr('href', '' + $hg_ll + '');
			$('.site-header__cart-toggle').attr('href', '' + $hg_cl + '');
			$('.search-button').attr('href', '' + $hg_sl + '');


		}
	});

	if (Cookies.get('lang_hg')) {
		$('.lang-nav-sub > span').html('UA');
		$('.lang_hg_uk').addClass('active');
		$('.lang_hg_en').removeClass('active');
		var lang_r = 'uk';
		var cur_d_url = window.location.host;


		var url_cur_n = document.location.href;
		var url_cur = document.location.pathname.substring(1)
		var add_turl = url_cur_n.replace("https://bevza.com/", "/uk/");

		var find_url_fl = url_cur.split("/");
		if (find_url_fl[0] !== 'uk') {
			//window.location.replace(''+add_turl+'');
		}

		$hg_ll = $('.log-in-button').attr('href');
		$hg_cl = $('.site-header__cart-toggle').attr('href');
		$hg_sl = $('.search-button').attr('href');
		$('.log-in-button').attr('href', '/uk' + $hg_ll + '');
		$('.site-header__cart-toggle').attr('href', '/uk' + $hg_cl + '');
		$('.search-button').attr('href', '/uk' + $hg_sl + '');


	} else {
		$('.lang-nav-sub > span').html('EN');
		$('#site-title').find('a').attr('href', '/');
		$('.lang_hg_en').addClass('active');
		$('.lang_hg_uk').removeClass('active');
		var cur_d_url = window.location.host;


		var url_cur_n = document.location.href;
		var url_cur = document.location.pathname.substring(1)
		var add_turl = url_cur_n.replace("https://bevza.com/uk/", "/");

		var find_url_fl = url_cur.split("/");
		if (find_url_fl[0] == 'uk') {
			//window.location.replace(''+add_turl+'');
		}

		$hg_ll = '/account/login';
		$hg_cl = '/cart/';
		$hg_sl = '/search/';
		$('.log-in-button').attr('href', '' + $hg_ll + '');
		$('.site-header__cart-toggle').attr('href', '' + $hg_cl + '');
		$('.search-button').attr('href', '' + $hg_sl + '');

	}
	//end lang nav




	$('#acc_i').on('click', function() {
		if (!$(this).hasClass('active')) {
			$(this).addClass('active');
			$('body').addClass('ac-open');
			$('body').addClass('sp-open');
		} else {
			$(this).removeClass('active');
			$('body').removeClass('ac-open');
			$('body').removeClass('sp-open');
		}
	});



	$('#cart-i').on('click', function() {
		if (!$(this).hasClass('active')) {
			$(this).addClass('active');
			$('body').addClass('mc-open');
			$('body').addClass('sp-open');
		} else {
			$(this).removeClass('active');
			$('body').removeClass('mc-open');
			$('body').removeClass('sp-open');
		}
	});
	$('#mc-close').on('click', function() {
		$('#cart-i.active').trigger('click');
	});

	$('.t-btn').on('click', function() {
		$('body').addClass('pt-open ');
		$('body').addClass('sp-open')
		$cn_tab = $(this).attr('data-t');
		$('.t-nav[data-t=' + $cn_tab + ']').trigger('click');
	});
	$('#close-tab').on('click', function() {
		$('body').removeClass('pt-open');
		$('body').removeClass('sp-open')
	});


	$('.stock-btn').on('click', function() {
		$('body').addClass('sa-open');
	});
	$('.t-nav').on('click', function() {
		if (!$(this).hasClass('active')) {
			$(this).addClass('active');
			$(this).nextAll().removeClass('active');
			$(this).prevAll().removeClass('active');
			$c_tab = $(this).attr('data-t');
			$('.t-cont[data-t=' + $c_tab + ']').slideDown();
			$('.t-cont[data-t=' + $c_tab + ']').addClass('active');
			$('.t-cont[data-t=' + $c_tab + ']').nextAll().removeClass('active');
			$('.t-cont[data-t=' + $c_tab + ']').prevAll().removeClass('active');
			$('.t-cont[data-t=' + $c_tab + ']').nextAll().slideUp();
			$('.t-cont[data-t=' + $c_tab + ']').prevAll().slideUp();

		}

	});
	$('.t-grid-h.stretched   .sp-s-tit').each(function(index) {
		if ($(window).width() < 1023) {
			$p_lef = $(this).position().left - 10;
		} else {
			$p_lef = $(this).position().left - 14;
		}

		$(this).parents('.t-grid-h').find('.bnt-name').css('padding-left', $p_lef);
	});
	$('#gall-items .bgcov').each(function(index) {
		$pc_i = $(this).attr('data-f-pc');
		$m_i = $(this).attr('data-f-m');
		if ($(window).width() > 1040) {

			$(this).css('background-image', 'url(' + $pc_i + ')');

		} else {
			if ($(this).hasClass('first-sl')) {
				$(this).css('background-image', 'url(' + $m_i + ')');
			} else {
				$(this).attr('data-flickity-bg-lazyload', $m_i);
			}
		}
	});

	$('#mob-v').on('click', function(event) {
		if (!$(this).hasClass('active')) {
			$(this).addClass('active');
			$('#prod-vid').addClass('active_v');
			$(this).next('#prod-vid').find('video').trigger('play');
			$('.sl-nav').fadeOut();
			$('#fs-gall').fadeOut();
		} else {
			$(this).removeClass('active');
			$('#prod-vid').removeClass('active_v');
			$(this).next('#prod-vid').find('vdeo').trigger('pause');
			$('.sl-nav').fadeIn();
			$('#fs-gall').fadeIn();
		}
	});

	$('.count-sl').on('change.flickity', function(event, index) {
		$slide_p = index + 1;
		$(this).parents('.has-sl').find('.sl-n-item.cur-sl').html($slide_p);
	});




	$('#close-filter').on('click', function() {
		$('body').removeClass('f-open');
		$('body').removeClass('sp-open');
	});
	$('#close-sort').on('click', function() {
		$('body').removeClass('s-open');
		$('body').removeClass('sp-open');
	});

	$('#s-btn').on('click', function() {
		$('#close-filter').trigger('click');
		$('body').addClass('s-open');
		$('body').addClass('sp-open');

	});

	$('.bapf_head').on('click', function() {
		if (!$(this).hasClass('active')) {
			$(this).addClass('active');
			$(this).next().slideDown();
		} else {
			$(this).removeClass('active');
			$(this).next().slideUp();
		}
	});

	$(".hg-prod.prod-arch").hover(function() {
		var sourceFile = $(this).find(".hg-ll-hov").attr("data-p-i");
		if ($(this).find(".hg-ll-hov").is('[style="background-image"]')) {} else {
			$(this).find(".hg-ll-hov").css('background-image', 'url(' + sourceFile + ')');
		};
	}, function() {});


	$('.hg-ll-sl .bgcov').each(function(index) {
		$pc_i = $(this).attr('data-f-pc');
		$m_i = $(this).attr('data-f-m');
		if ($(window).width() > 1040) {
			if ($(this).hasClass('first-sl')) {
				$(this).css('background-image', 'url(' + $pc_i + ')');
			} else {
				$(this).attr('data-flickity-bg-lazyload', $pc_i);
			}
		} else {
			if ($(this).hasClass('first-sl')) {
				$(this).css('background-image', 'url(' + $m_i + ')');
			} else {
				$(this).attr('data-flickity-bg-lazyload', $m_i);
			}
		}
	});



	$('#home-sl .hg-video').each(function(index) {
		$pc_v = $(this).attr('data-v-pc');
		$m_v = $(this).attr('data-v-m');
		if ($(window).width() > 1040) {
			if ($(this).hasClass('first-sl')) {
				$(this).find('source').attr('src', $pc_v);
				$(this).trigger('play');
			} else {
				$(this).find('source').attr('src', $pc_v);
			}
		} else {
			if ($(this).hasClass('first-sl')) {
				$(this).find('source').attr('src', $m_v);
				$(this).trigger('load');
				$(this).trigger('play');
			} else {
				$(this).find('source').attr('src', $m_v);
				$(this).trigger('load');

			}
		}
	});

	$('#home-sl').flickity().on('change.flickity', function(event, index) {
		$slide_p = index + 1;
		$('.sl-item:nth-child(' + $slide_p + ')').find('.hg-video').trigger('play');
		$('.sl-item:nth-child(' + $slide_p + ')').nextAll().find('.hg-video').trigger('pause');
		$('.sl-item:nth-child(' + $slide_p + ')').prevAll().find('.hg-video').trigger('pause');
		$(this).parents('.has-sl').find('.cur-sl').html($slide_p);
		$('.tit-links div[sl-c=' + index + ']').addClass('active');
		$('.tit-links div[sl-c=' + index + ']').nextAll().removeClass('active');
		$('.tit-links div[sl-c=' + index + ']').prevAll().removeClass('active');
	});
});
